module.exports = __webpack_public_path__ + "img/logo-kanggo.170a225d.png";